import { axiosInstance } from '@fides/fides-react-components';
import { endpoints } from 'core/consts';

export type StatusHistoryDto = {
  statusTimeStamp?: string | number;
  status?: string;
  reasonCode?: string;
};

/**
 * Fetch status history for a transaction/order by id.
 * Backend: GET /transactions/status-history/{id}
 */
export const getStatusHistory = async (id: string): Promise<StatusHistoryDto[]> => {
  const { data } = await axiosInstance.get<StatusHistoryDto[]>(
    `/transactions/status-history/${encodeURIComponent(id)}`,
    {
      baseURL: endpoints.EFTApiUrl,
    }
  );
  return data ?? [];
};
